module.exports = __webpack_public_path__ + "static/media/footer-icon-closed.86c21f13.svg";